export default function PHP_stristr() {
  return (
    <div>
      <h1>PHP_stristr</h1>
    </div>
  );
}
